import { render, staticRenderFns } from "./AcademyCardPromotion.vue?vue&type=template&id=5ab6d572&"
import script from "./AcademyCardPromotion.vue?vue&type=script&lang=js&"
export * from "./AcademyCardPromotion.vue?vue&type=script&lang=js&"
import style0 from "./AcademyCardPromotion.vue?vue&type=style&index=0&id=5ab6d572&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports